import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/cart";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirm from "@/pages/OrderConfirm";
import Track from "@/pages/Track";
import ComingSoon from "@/pages/ComingSoon";
import FAQ from "@/pages/FAQ";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProductForm from "@/pages/admin/AdminProductForm";
import AdminImportCsv from "@/pages/admin/AdminImportCsv";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminOrderDetail from "@/pages/admin/AdminOrderDetail";
import AdminProduction from "@/pages/admin/AdminProduction";
import AdminQuestions from "@/pages/admin/AdminQuestions";
import AdminFAQ from "@/pages/admin/AdminFAQ";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminWaitlist from "@/pages/admin/AdminWaitlist";
import AdminDiscounts from "@/pages/admin/AdminDiscounts";
import AdminBulkImages from "@/pages/admin/AdminBulkImages";
import AdminUnassignedImages from "@/pages/admin/AdminUnassignedImages";
import AdminInventory from "@/pages/admin/AdminInventory";

function Storefront({ children }) { return <Layout>{children}</Layout>; }

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" />
        <Routes>
          <Route path="/" element={<Storefront><Home /></Storefront>} />
          <Route path="/shop" element={<Storefront><Shop /></Storefront>} />
          <Route path="/product/:slug" element={<Storefront><ProductDetail /></Storefront>} />
          <Route path="/cart" element={<Storefront><Cart /></Storefront>} />
          <Route path="/checkout" element={<Storefront><Checkout /></Storefront>} />
          <Route path="/order/:orderNumber" element={<Storefront><OrderConfirm /></Storefront>} />
          <Route path="/track" element={<Storefront><Track /></Storefront>} />
          <Route path="/coming-soon" element={<Storefront><ComingSoon /></Storefront>} />
          <Route path="/faq" element={<Storefront><FAQ /></Storefront>} />
          <Route path="/about" element={<Storefront><About /></Storefront>} />
          <Route path="/contact" element={<Storefront><Contact /></Storefront>} />
          <Route path="/categories" element={<Storefront><Shop /></Storefront>} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="products/:id" element={<AdminProductForm />} />
            <Route path="import" element={<AdminImportCsv />} />
            <Route path="images/bulk" element={<AdminBulkImages />} />
            <Route path="images/unassigned" element={<AdminUnassignedImages />} />
            <Route path="inventory" element={<AdminInventory />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="orders/:id" element={<AdminOrderDetail />} />
            <Route path="production" element={<AdminProduction />} />
            <Route path="questions" element={<AdminQuestions />} />
            <Route path="waitlist" element={<AdminWaitlist />} />
            <Route path="discounts" element={<AdminDiscounts />} />
            <Route path="faqs" element={<AdminFAQ />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}
export default App;
